import * as url from "../url_helper";

import { get, post } from "../api_helper";

export const getRoleDataAccessList = data => post(url.GET_ROLE_DATA_ACCESS_LIST, data);

// export const updateRoleDataAccess = data => post(url.EDIT_ROLEPERMISSION_LIST , data)

export const addRoleDataAccess = data => post(url.ADD_ROLE_DATA_ACCESS, data);

export const updateRoleDataAccess = data => post(url.UPDATE_ROLE_DATA_ACCESS, data);

export const getRoleDataAccessOptions = data => get(url.GET_ROLE_DATA_ACCESS_OPTIONS, data);

export const deleteRoleDataAccessById = data => post(url.DELETE_ROLE_DATA_ACCESS_BY_ID, data);

export const getRoleDataAccessById = data => post(url.GET_ROLE_DATA_ACCESS_BY_ID, data);

export const getDataAccessForRole = data => post(url.CHECK_DATA_ACCESS, data);